import { addRefWithOptions } from '@/Utils/UrlUtility';
import { computed } from 'vue';

export function useMappedCreators({
    creator,
    coCreators,
    urlRefOptions = {},
    nameKey = 'name',
    avatarUrlKey = 'avatarUrl',
    homeUrlKey = 'homeUrl',
}) {

    const mappedCreator = computed(() => ({
        name: creator.value[nameKey],
        avatarUrl: creator.value[avatarUrlKey],
        url: addRefWithOptions(creator.value[homeUrlKey], urlRefOptions),
    }));

    const mappedCoCreators = computed(() => coCreators.value.map(c => ({
        name: c[nameKey],
        avatarUrl: c[avatarUrlKey],
        url: addRefWithOptions(c[homeUrlKey], urlRefOptions),
    })));

    const coCreatorsCount = computed(() => mappedCoCreators.value.length);
    const hasCoCreators = computed(() => coCreatorsCount.value > 0);
    const hasOneCoCreator = computed(() => coCreatorsCount.value === 1);
    const hasMultipleCoCreators = computed(() => coCreatorsCount.value > 1);
    const firstCoCreator = computed(() => mappedCoCreators.value[0] || null);

    return {
        mappedCoCreators,
        mappedCreator,
        coCreatorsCount,
        hasCoCreators,
        hasOneCoCreator,
        hasMultipleCoCreators,
        firstCoCreator,
    };
}